export enum SessionStoreItem {
  IdToken,
  UserId
};
